import React from 'react';
import { Modal } from 'reactstrap';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AssetListTable } from './Common';

const AssetGroupListModal = ({ isOpen, toggle, title, subtitle, assets, onAssetClick }) => {
  const { t } = useTranslation();
  const items = assets || [];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.2 }}
      >
        <div className="modal-header border-0 pb-0 d-flex align-items-start">
          <div className="flex-grow-1">
            <h5 className="modal-title fw-bold mb-1">{title}</h5>
            {subtitle && <p className="text-muted mb-0 small">{subtitle}</p>}
          </div>
          <motion.button
            type="button"
            className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
            onClick={toggle}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            style={{ width: '36px', height: '36px', padding: 0 }}
            aria-label="Close"
          >
            <X size={18} />
          </motion.button>
        </div>
        <div className="modal-body pt-3">
          <AssetListTable
            data={items}
            onAssetClick={onAssetClick}
            emptyMessage={t('shared.no_assets_found', 'No assets found')}
          />
        </div>
      </motion.div>
    </Modal>
  );
};

export default AssetGroupListModal;
